import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpModule } from '@angular/http';
import * as MasterConstants from '../masterconstants'; 
import { Headers, Response, URLSearchParams } from '@angular/http';

@Injectable()
export class UserForgotPasswordService {

    constructor(private http: Http) {
    }

    forgotPassword(values) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        let urlSearchParams = new URLSearchParams();

        urlSearchParams.append('email',values['email']);
        urlSearchParams.append('username',values['username']);
        urlSearchParams.append('action', 'forgotpassword');
        let body = urlSearchParams.toString();

        return this.http.post(MasterConstants.WEB_URL + 'forgotPassword.php', body, {
            headers: headers
        }).map(res => res.json());
    }

    resetPassword(values, securityKey) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        let urlSearchParams = new URLSearchParams();

        urlSearchParams.append('password',values['password']);
        urlSearchParams.append('passwordHash', securityKey);
        urlSearchParams.append('action', 'resetpassword');
        let body = urlSearchParams.toString();

        return this.http.post(MasterConstants.WEB_URL + 'forgotPassword.php', body, {
            headers: headers
        }).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/forgotPassword/forgotPassword.service.ts